import classNames from 'classnames';
import { Button } from 'components/Button';
import { ButtonTogglerProps } from '../types';

const ButtonToggler: React.FC<ButtonTogglerProps> = ({
  type,
  prevStep,
  backTitle = 'Back',
  nextStep,
  nextTitle = 'Next',
  currentStep,
  isLoading,
  disabled,
  buttonClassName = '',
}) => {
  return (
    <header className="sticky bottom-0  left-0 right-0 z-[5] mt-auto flex h-[5.5rem] w-full items-center justify-center border-t border-color-border-input-lightmode bg-color-bg-lightmode-primary pb-4 pl-8 pr-8 pt-4 dark:bg-color-bg-darkmode-primary xs:gap-4 md:gap-6">
      <Button
        onClick={prevStep}
        variant="secondary"
        className={classNames('xs:w-full lg:w-32', buttonClassName)}
        size="lg"
      >
        {backTitle}
      </Button>
      {nextStep && (
        <Button
          variant="primary"
          size="lg"
          onClick={nextStep}
          type={type}
          disabled={isLoading || disabled}
          className={classNames('xs:w-full lg:w-32', buttonClassName)}
        >
          {isLoading ? 'Loading...' : nextTitle}
        </Button>
      )}
    </header>
  );
};

export default ButtonToggler;
